import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link, useSearchParams } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import apiService from "../Common/Configurations/APIService";
import './Login.css';
import config from "../Common/Configurations/APIConfig";
import { useAuth } from "../Common/Configurations/AuthContext";
import DefaultData from '../CompanyData/DefaultData';
const keyHighlights = [
    { value: '5000+', label: 'Flight Journeys worldwide' },
    { value: '400,000+', label: 'Hotel & Apartment Rooms' },
    { value: '1000+', label: 'Directly Contracted Hotels' },
    { value: '20,000+', label: 'Sightseeing Items & Tours' },
];
const agentBenefits = [
    { icon: 'ri-calendar-check-line', title: 'Easy Bookings', text: 'A seamless platform to effortlessly organize your clients\' next adventure.' },
    { icon: 'ri-compass-3-line', title: 'Best Destinations', text: 'Our curated selection of destinations promises unforgettable adventures.' },
    { icon: 'ri-book-open-line', title: 'Travel Guides', text: 'Packed with insider tips and expert advice to unlock each destination.' },
    { icon: 'ri-customer-service-2-line', title: 'Friendly Support', text: 'Our team is dedicated to ensuring your journey is smooth and stress-free.' },
];
const initialLoginValues = {
    email: '',
    password: ''
};

export default function ResetPassword() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [token, setToken] = useState("");
    const [email, setEmail] = useState("");
    const [values, setValues] = useState(initialLoginValues);
    const [errors, setErrors] = useState({});
    const [btnSubmit, setBtnSubmit] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value,
        });
    };

    const validate = () => {
        let temp = {};
        temp.password = values.password === '' ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            setBtnSubmit(true);
            const formData = {
                "email": email,
                "password": values.password,
                "token": token.trim(),
                "domainUrl": window.location.origin
            };
            try {
                var result = await apiService.post(config.RESETPASSWORD, formData);
                alert(result?.message);
            } catch (error) {
                console.error("Login failed:", error);

            } finally {
                setBtnSubmit(false);
            }
        }
    };
    const pageThemeStyles = {
        '--theme-primary-color': DefaultData.THEMECOLOR1,
        '--theme-secondary-color': DefaultData.THEMECOLOR2,
    };
    const applyErrorClass = (field) =>
        field in errors && errors[field] === false ? ' form-control-danger' : '';
    useEffect(() => {
        if (searchParams === null) {
            navigate('/')
        }
        else {
            setEmail(searchParams.get("email"))
            var letparams = searchParams.toString();
            var splitparams = letparams.split('=')
            setToken(splitparams[2])
        }
    }, [])
    return (
        <div style={pageThemeStyles}>
            <div className="auth-back-cover">
                <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
                    <div className="auth-page-content overflow-hidden">
                        <Container>
                            <Row className="align-items-center">
                                <Col lg={7} className="d-none d-lg-block">
                                    <div className="main-banner">
                                        <h1>{DefaultData?.LANDINGPAGETITLE}</h1>
                                        <p>{DefaultData?.LANDINGPAGESUBTITLE}</p>
                                        <div className="vector-images">
                                            <div className="vector-item"><span><i className="ri-plane-line" /></span><p>Flights</p></div>
                                            <div className="vector-item"><span><i className="ri-building-line" /></span><p>Hotels</p></div>
                                            <div className="vector-item"><span><i className="ri-car-line" /></span><p>Cars</p></div>
                                            <div className="vector-item"><span><i className="ri-bus-line" /></span><p>Bus</p></div>
                                            <div className="vector-item"><span><i className="ri-luggage-deposit-line" /></span><p>Holidays</p></div>
                                            <div className="vector-item"><span><i className="ri-book-line" /></span><p>Visas</p></div>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={5} md={8}>
                                    <div className="card overflow-hidden rounded-4 loginbox">
                                        <div className="row g-0">
                                            <div className="p-lg-5 p-4">
                                                <h3 className='text-center'>{DefaultData?.DEFAULTBRANDNAME}</h3>
                                                <p className="text-muted text-center">Reset Password</p>
                                                <div className="mt-4">
                                                    <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                                                        <div className="mb-3">
                                                            <label htmlFor="email" className="form-label">Username</label>
                                                            <input className={'form-control' + applyErrorClass('email')} name="email" type="text" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="Enter Email" />
                                                            {errors.email === false ? (<div className="validationerror">Please enter email</div>) : ('')}
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label" htmlFor="password-input">Password</label>
                                                            <div className="position-relative auth-pass-inputgroup mb-1">
                                                                <input className={'form-control' + applyErrorClass('password')} name="password" type={showPassword ? 'text' : 'password'} value={values.password} onChange={handleInputChange} placeholder="Password" />
                                                                <span className="password-toggle-icon" onClick={togglePasswordVisibility}><i className={showPassword ? "ri-eye-fill" : "ri-eye-off-fill"}></i></span>
                                                            </div>
                                                            {errors.password === false && (<div className="validationerror">Please enter password</div>)}
                                                        </div>
                                                        <div className="mt-4 d-grid">
                                                            {btnSubmit === false ?
                                                                (<button type="submit" className="btn btn-primary w-100">Reset Password</button>) :
                                                                (<button type="button" className="btn btn-primary w-100" disabled><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Please wait...</button>)
                                                            }
                                                        </div>
                                                    </form>
                                                </div>
                                                <div className="mt-5 text-center">
                                                    <div className="auth-footer">
                                                        <p className="mb-2">Don't have an account?{" "}
                                                            {/* UPDATED: Removed text-primary class */}
                                                            <Link to="/agentregister" className="fw-semibold text-decoration-underline">Register</Link>
                                                        </p>
                                                        {/* <p className="mb-0">
                              <Link to="/forgot-password" className="fw-semibold text-decoration-underline">Forgot Password?</Link>
                            </p> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </div>
            <div className="page-content-below-hero">
                <Container>
                    <section className="text-center py-5">
                        <h2 className="section-title-light">Key Highlights</h2>
                        <p className="section-subtitle-light">Empowering Travel Agents with a Global B2B Online Reservation System</p>
                        <Row className="g-4 mt-4">
                            {keyHighlights.map(item => (
                                <Col md={6} lg={3} key={item.label}>
                                    <div className="highlight-card">
                                        <h3>{item.value}</h3>
                                        <p>{item.label}</p>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </section>
                    <section className="text-center py-5">
                        <h2 className="section-title-light">Experience the Future of Travel Distribution</h2>
                        <p className="section-subtitle-light">A Rewarding Journey for Travel Partners</p>
                        <Row className="g-4 mt-4">
                            {agentBenefits.map(item => (
                                <Col md={6} lg={3} key={item.title}>
                                    <Card className="benefit-card h-100">
                                        <Card.Body>
                                            <div className="benefit-icon"><i className={item.icon}></i></div>
                                            <Card.Title as="h5" className="mt-3">{item.title}</Card.Title>
                                            <Card.Text>{item.text}</Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </section>
                </Container>
            </div>
        </div>
    );
}